import { useAuth0 } from "@auth0/auth0-react";
import Popover from "@material-ui/core/Popover";
import { GridViewStreamIcon } from "@material-ui/data-grid";
import FinanceService from "Lib/API/Finance";
import { ReactComponent as Download } from "assets/icons/DownloadIcon.svg";
import { ReactComponent as PayNowSvg } from "assets/icons/Property.svg";
import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import { ReactComponent as Visibilit } from "assets/icons/eyeIcon.svg";
import { ReactComponent as Invoice } from "assets/icons/invoice.svg";
import { ReactComponent as Reciept } from "assets/icons/receipt.svg";
import ReplayIcon from "@material-ui/icons/Replay";
import { ReactComponent as PausedIcon } from "assets/icons/PausedIcon.svg";
import { BsPauseCircle } from "react-icons/bs";
import { ReactComponent as RecurringIcon } from "assets/icons/recurring-icon.svg";
import { ReactComponent as SharePaymentIcon } from "assets/icons/SharePaymentIcon.svg";
import DeleteSvgComponent from "assets/icons/svg/DeleteSvg/Delete";
import EditSvgComponent from "assets/icons/svg/Edit/index";
import EyeSvgComponent from "assets/icons/svg/EyeSvg/Eye";
import MyButton from "components/MyButton";
import React from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import exportImg, { ReactComponent as ShareSvgComponent } from "../assets/icons/Share.svg";
import { ReactComponent as ShareSvg } from "../assets/icons/ShareWhite.svg";

import { ReactComponent as Delete } from "assets/icons/DeleteWhite.svg";
import { ReactComponent as Edit } from "assets/icons/EditWhite.svg";
import { ReactComponent as LetterYahIcon } from "assets/icons/letter_yah.svg";
import { ReactComponent as InstallmentIcon } from 'assets/icons/recurring-white-icon.svg';
import ActionSvgComponent from "../assets/icons/svg/actionSvg";
import { showBatchBillingTable } from "../store/redux/actions";
import AlertDialog from "./Dialog";
import { IconButton } from "./IconButton";

import "./style.scss";
import { fontConfig } from "theme/fontConfig";

export default function FinancePopover({
  reversalCheck = false,
  drawerBol = false,
  setInvoiceFile,
  setShareInvoicePDF,
  setShareReceiptPDF,
  setReceiptFile,
  setInvoiceDownload,
  setReceiptDownload,
  onViewClick,
  onSharePymentClick,
  onPayClick,
  onUpdateClick,
  onDeleteClick,
  onCancelClick,
  onUpdatePaymentClick,
  OnRecurringAction,
  onChargeEditClick,
  onReversalClick,
  style,
  action,
  id: batch_id,
  status,
  handleClick,
  handleBatchId,
  onEditNowClick,
  onCancelPaymentClick,
  actionDrawer,
  rowId,
  row,
  setOpen,
  chargeStatus,
  checkData,
  hideInvoiceButtons,
  hideReceiptButtons,
  disableSharePaymentLink,
  disableDeleteButton,
  onAddClick,
  onSendLetterClick,
  onUpdatePaymentMethod,
  enableUpdatePaymentMethod,
  disableActionButton,
}) {
  const dispatch = useDispatch();
// console.log('this is the popup opening')
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openConfirmAlert, setOpenConfirmAlert] = React.useState(false);
  const [deleteLoading, setDeleteLoading] = React.useState(false);
  const handleOnClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const { getAccessTokenSilently } = useAuth0();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const onCompleteBatchPayment = async () => {
    const token = await getAccessTokenSilently();
    FinanceService.completeBatchPayment(batch_id, token).then((res) => {
      handleClose();
      toastr.success("Success", "Successfully Completed");
      window.dispatchEvent(new CustomEvent("refresh"));
    });
  };

  const onCloneBatchPayment = async () => {
    const token = await getAccessTokenSilently();
    FinanceService.cloneBatchPayment(batch_id, token).then((res) => {
      handleClose();
      toastr.success("Success", "Successfully Cloned");
      window.dispatchEvent(new CustomEvent("refresh"));
    });
  };
  const onPauseBatchPayment = async () => {
    const token = await getAccessTokenSilently();
    FinanceService.pauseBatchPayment(batch_id, token).then((res) => {
      handleClose();
      toastr.success("Success", "Successfully Paused");

      window.dispatchEvent(new CustomEvent("refresh"));
    });
  };
  const onDeleteBatchPayment = async () => {
    if(deleteLoading) return;
    setDeleteLoading(true);
    const token = await getAccessTokenSilently();
    FinanceService.deleteBatchPayment(batch_id, token).then((res) => {
      handleClose();
      toastr.success("Success", "Successfully Deleted");
      window.dispatchEvent(new CustomEvent("refresh"));
    })
    .catch((error) => {
      toastr.error(error?.data?.message || "Something went wrong");
    })
    .finally(() => {
      setOpenConfirmAlert(false);
      setDeleteLoading(false);
    });
  };

  return (
    <div>
      <ActionSvgComponent
        height={style ? style.height : 14}
        width={style ? style.width : 14}
        onClick={disableActionButton ? undefined : handleOnClick}
        color={disableActionButton ? "#999" : (style && style.color)}
        style={disableActionButton ? { cursor: "default", pointerEvents: "none", opacity: 0.6 } : undefined}
      />
      {action === "finance" ? (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          className="finance__options"
        >
          {/* Receipt / Invoice buttons for payment rows inside drawer */}
          {actionDrawer === "drawer" && row?.charge?.status === "payment" ? (
            <>
              {!hideReceiptButtons && (
                <p className="drawer-row my-2 mx-6 d-flex py-3">
                  <Reciept className="" />
                  <div className="mr-4 pr-4 mt-2">Receipt</div>
                  <div className="d-flex">
                    <Visibilit className="cursor-pointer mx-2" onClick={setReceiptFile} />
                    <Download className="cursor-pointer mx-2" onClick={setReceiptDownload} />
                    <IconButton className="cursor-pointer btn p-0 mx-2" size="large" financeDrawer="financeDrawer" onClick={setShareReceiptPDF}>
                      <img src={exportImg} alt="export" />
                    </IconButton>
                  </div>
                </p>
              )}
              {!hideInvoiceButtons && (
                <p className="drawer-row my-2 mx-6 d-flex py-3">
                  <Invoice />
                  <div className="mr-4 pr-4 mt-2">Invoice</div>
                  <div className="d-flex">
                    <Visibilit className="cursor-pointer mx-2" onClick={setInvoiceFile} />
                    <Download className="cursor-pointer mx-2" onClick={setInvoiceDownload} />
                    <IconButton className="cursor-pointer btn p-0 mx-2" size="large" financeDrawer="financeDrawer" onClick={setShareInvoicePDF}>
                      <img src={exportImg} alt="export" />
                    </IconButton>
                  </div>
                </p>
              )}
            </>
          ) : null}

          <div style={{ width: 200, fontFamily: fontConfig.FinancePopoverTextFont.family, fontSize: 14, overflow: "hidden", display: "flex", flexDirection: "column" }}>

            {/* Edit — recurring */}
            {actionDrawer !== "drawer" && onUpdateClick && row?.charge?.sub_status !== "opposite" && row?.isRecurring && row?.charge?.payment?.status !== "declined" && row?.recurringDetails?.recurringType !== "recurringExternal" ? (
              <div
                className="edit-pop-over"
                style={{ color: "#002E5C", opacity: row?.recurringDetails?.recurringStatus === "disable" ? 0.4 : 1, pointerEvents: row?.recurringDetails?.recurringStatus === "disable" ? "none" : "auto" }}
                onClick={() => { onUpdateClick(); handleClose(); }}
              >
                <EditSvgComponent className="svg-size" /> Edit
              </div>
            ) : null}

            {/* Edit — installment */}
            {actionDrawer !== "drawer" && onUpdateClick && !row?.isRecurring && row?.charge?.payment?.status !== "declined" && row?.recurringDetails?.recurringType !== "recurringExternal" ? (
              <div
                className="edit-pop-over"
                style={{ color: "#002E5C", opacity: row?.recurringDetails?.recurringStatus === "disable" ? 0.4 : 1, pointerEvents: row?.recurringDetails?.recurringStatus === "disable" ? "none" : "auto" }}
                onClick={() => { onUpdateClick(); handleClose(); }}
              >
                <EditSvgComponent className="svg-size" /> Edit
              </div>
            ) : null}

            {/* Pay Now */}
            {onPayClick && !row?.isRecurring && row?.charge?.payment?.status !== "declined" ? (
              <div
                className="edit-pop-over"
                style={{ color: "#002E5C", opacity: (chargeStatus === "close" || row?.charge?.amount === 0 || checkData?.length > 1) ? 0.4 : 1, pointerEvents: (chargeStatus === "close" || row?.charge?.amount === 0 || checkData?.length > 1) ? "none" : "auto" }}
                onClick={() => { onPayClick(); handleClose(); }}
              >
                <PayNowSvg width={18} height={18} className="svg-size" style={{ filter: "brightness(0) saturate(100%) invert(29%) sepia(96%) saturate(2000%) hue-rotate(218deg) brightness(105%)" }} /> Pay Now
              </div>
            ) : null}

            {/* Update Payment Info — for declined recurring */}
            {(onPayClick || onUpdatePaymentClick) && row?.charge?.payment?.status === "declined" && row?.isRecurring ? (
              <div
                className="edit-pop-over"
                style={{ color: "#002E5C" }}
                onClick={() => { onUpdatePaymentClick && onUpdatePaymentClick(); handleClose(); }}
              >
                <PayNowSvg width={18} height={18} className="svg-size" style={{ filter: "brightness(0) saturate(100%) invert(29%) sepia(96%) saturate(2000%) hue-rotate(218deg) brightness(105%)" }} /> Update Payment Info
              </div>
            ) : null}

            {/* Update Payment Info — for active recurring/installment */}
            {enableUpdatePaymentMethod ? (
              <div
                className="edit-pop-over"
                style={{ color: "#002E5C" }}
                onClick={() => { onUpdatePaymentMethod(); handleClose(); }}
              >
                <PayNowSvg width={18} height={18} className="svg-size" style={{ filter: "brightness(0) saturate(100%) invert(29%) sepia(96%) saturate(2000%) hue-rotate(218deg) brightness(105%)" }} /> Update Payment Info
              </div>
            ) : null}

            {/* Share Payment Link */}
            {onSharePymentClick && !row?.isRecurring && row?.charge?.payment?.status !== "declined" ? (
              <div
                className="edit-pop-over"
                style={{ color: "#002E5C", opacity: (disableSharePaymentLink || chargeStatus === "close" || row?.charge?.amount === 0 || checkData?.length > 1) ? 0.4 : 1, pointerEvents: (disableSharePaymentLink || chargeStatus === "close" || row?.charge?.amount === 0 || checkData?.length > 1) ? "none" : "auto" }}
                onClick={() => { onSharePymentClick(); handleClose(); }}
              >
                <SharePaymentIcon width={16} height={16} className="svg-size" /> Share Payment Link
              </div>
            ) : null}

            {/* On Hold / Activate — recurring */}
            {OnRecurringAction && row?.isRecurring && row?.charge?.payment?.status !== "declined" && row?.recurringDetails?.recurringStatus !== "completed" ? (
              <div
                className="edit-pop-over"
                style={{ color: "#002E5C", opacity: row?.recurringDetails?.recurringStatus === "disable" ? 0.4 : 1, pointerEvents: row?.recurringDetails?.recurringStatus === "disable" ? "none" : "auto" }}
                onClick={() => {
                  if (row?.recurringDetails?.hasProvider === false && row?.recurringDetails?.recurringStatus === "on-hold") {
                    onUpdatePaymentMethod && onUpdatePaymentMethod();
                  } else if (row?.recurringDetails?.recurringStatus === "on-hold") {
                    OnRecurringAction("active");
                  } else {
                    OnRecurringAction("on-hold");
                  }
                  handleClose();
                }}
              >
                <BsPauseCircle size={16} className="svg-size" />
                {row?.recurringDetails?.recurringStatus === "on-hold" ? "Activate" : "On Hold"}
              </div>
            ) : null}

            {/* Cancel — recurring */}
            {OnRecurringAction && row?.isRecurring && row?.recurringDetails?.recurringStatus !== "completed" ? (
              <div
                className="edit-pop-over"
                style={{ color: "#002E5C", opacity: row?.recurringDetails?.recurringStatus === "disable" ? 0.4 : 1, pointerEvents: row?.recurringDetails?.recurringStatus === "disable" ? "none" : "auto" }}
                onClick={() => { onCancelClick && onCancelClick(); handleClose(); }}
              >
                <PausedIcon width={16} height={16} className="svg-size" /> Cancel
              </div>
            ) : null}

            {/* Cancel Installments */}
            {onCancelPaymentClick && !row?.isRecurring ? (
              <div
                className="edit-pop-over"
                style={{ color: "#002E5C" }}
                onClick={() => { onCancelPaymentClick(); handleClose(); }}
              >
                <PausedIcon width={16} height={16} className="svg-size" /> Cancel Installments
              </div>
            ) : null}

            {/* Reversal */}
            {reversalCheck && row?.charge?.status !== "charge" && onReversalClick && row?.charge?.sub_status !== "reversal" && rowId !== true && row?.charge?.payment?.status !== "reversal" ? (
              <div
                className="edit-pop-over"
                style={{ color: "#002E5C" }}
                onClick={() => { onReversalClick(); handleClose(); }}
              >
                <ReplayIcon style={{ fontSize: 16, marginRight: 4, color: "#575757", transform: "scaleX(-1)" }} /> Reversal
              </div>
            ) : null}

            {/* Delete */}
            {onDeleteClick && (!row?.isRecurring || parseFloat(row?.charge?.paid) === 0) ? (
              <div
                className="delete-pop-over"
                style={{ color: "#FF0A0A", paddingLeft: 10, opacity: (disableDeleteButton || row?.charge?.paid > 0) ? 0.4 : 1, pointerEvents: (disableDeleteButton || row?.charge?.paid > 0) ? "none" : "auto" }}
                onClick={() => { onDeleteClick(); handleClose(); }}
              >
                <DeleteSvgComponent className="svg-size" /> Delete
              </div>
            ) : null}

          </div>
        </Popover>
      ) : action === "tribute" ? (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {onAddClick && (
            <div className="billing-action-pop-over eye">
              <div className="finance-pop-over" onClick={onAddClick}>
                <AddIcon 
                  className="mr-6" 
                  width={18}
                  height={18}
                /> Add Attributes
              </div>
            </div>
          )}
          {onViewClick && (
            <div className="billing-action-pop-over eye">
              <div className="finance-pop-over" onClick={onViewClick}>
                <EyeSvgComponent 
                  className="mr-6" 
                  width={18}
                  height={18}
                /> View
              </div>
            </div>
          )}
          {onEditNowClick && (
            <div className="billing-action-pop-over">
              <div className="finance-pop-over" onClick={onEditNowClick}>
                <EditSvgComponent className="mr-6" /> Edit
              </div>
            </div>
          )}
          {onSendLetterClick && (
            <div className="billing-action-pop-over">
              <div className="finance-pop-over" onClick={onSendLetterClick}>
                <LetterYahIcon 
                  className="mr-6"
                  width={18}
                  height={18}
                /> Send Letter
              </div>
            </div>
          )}
        </Popover>
      ) : (
        <div>
          {" "}
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            {status === "draft" || status === "inProgress" ? null : (
              <div className="billing-action-pop-over">
                {console.log(status,'this is the popup opening')}
                <div
                  className="finance-pop-over"
                  onClick={() => {
                    handleClick("Batch Billing", batch_id);
                    handleBatchId();
                    dispatch(showBatchBillingTable(true));
                    setOpen(true);
                    handleClose();
                  }}
                >
                  View Transactions
                </div>
              </div>
            )}
            {status === "draft" ? (
              <div className="billing-action-pop-over">
                <div className="finance-pop-over " onClick={onEditNowClick}>
                  Edit
                </div>
              </div>
            ) : null}
            {status !== "inProgress" ? <div className="billing-action-pop-over">
              <div className="finance-pop-over " onClick={onCloneBatchPayment}>
                Clone
              </div>
            </div> : null}
            {status === "completed" ? (
              <div className="billing-action-pop-over">
                <div
                  className="finance-pop-over "
                  onClick={onPauseBatchPayment}
                >
                  Pause
                </div>
              </div>
            ) : null}
            {status === "completed" || status === "draft" || status === "inProgress" ? null : (
              <div className="billing-action-pop-over">
                <div
                  className="finance-pop-over "
                  onClick={onCompleteBatchPayment}
                >
                  Complete
                </div>
              </div>
            )}
            {(status === "paused" || status === "draft") && (
              <div className="billing-action-pop-over">
                <div
                  className="finance-pop-over "
                  style={{ color: "red" }}
                  onClick={() => {
                    setOpenConfirmAlert(true);
                  }}
                >
                  Delete
                </div>
              </div>
            )}
          </Popover>
        </div>
      )
      }

      <AlertDialog
        open={openConfirmAlert}
        onDecline={() => {
          setOpenConfirmAlert(false);
        }}
        onAccept={() => {
          onDeleteBatchPayment()
        }}
        title={`Are you sure?`}
        description={"Do you want to delete this bulk charge?"}
        disabled={deleteLoading}
      />
    </div >
  );
}